import { useState, useEffect } from 'react';
import { auth } from '../firebase'; // Firebase初期化のパスは実際の場所に合わせて
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  onAuthStateChanged
} from 'firebase/auth';

const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const signUp = async (email, password) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  };

  const signIn = async (email, password) => {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  };

  const signOutUser = async () => {
    await signOut(auth);
  };

  /* ▼★ パスワード再設定メール送信 */
  const resetPassword = async (email) => {
    if (!email) throw new Error('email-required');
    await sendPasswordResetEmail(auth, email);
  };

  return { user, loading, signUp, signIn, signOut: signOutUser, resetPassword };
};

export default useAuth;